import { isEmpty } from "lodash";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useContext } from "react";
import AuthProvider from "../context/AuthContext";
import BetSlipContext from "../context/BetSlipContext";
import { apiGet } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";
import obj from "../Utils/constants";
const headTh = {
  background: "#eef3f4",
  color: "#1e1e1e",
  fontSize: "13px",
  fontWeight: 700,
  textAlign: "center",
  padding: "7px 0",
  borderBottom: "1px solid #d9dede",
  width: "50%",
};
const rowTd = {
  fontSize: "13px",
  textAlign: "center",
  padding: "7px 0",
  borderBottom: "1px solid #eee",
  color: "#1e1e1e",
};

const BookPosition = () => {
  let { setBookPosition, bookposition, setBookPositionData, bookpositionData } =
    useContext(BetSlipContext);
  let { user } = useContext(AuthProvider);
  const [data, setData] = useState([]);
  const getFancyBetPosition = async () => {
    const { status, data: response_users } = await apiGet(
      apiPath.bookPosition +
      `?eventId=${bookpositionData.eventId}&type=${obj.betCheckObj[bookpositionData.categoryType]
      }&selectionId=${bookpositionData.selectionId}&marketId=${bookpositionData.marketId
      }`
    );

    if (status === 200) {
      if (response_users.success) {
        setData(response_users.results);
      }
    }
  };
  const [isDesktop, setIsDesktop] = useState(
    () => typeof window !== "undefined" && window.matchMedia("(min-width: 1024px)").matches
  );
  useEffect(() => {
    const media = window.matchMedia("(min-width: 1024px)");
    const update = () => setIsDesktop(media.matches);
    media.addEventListener("change", update);
    return () => media.removeEventListener("change", update);
  }, []);

  useEffect(() => {
    if (bookposition && !isEmpty(bookpositionData) && !isEmpty(user)) {
      setData([]);
      getFancyBetPosition();
    }
  }, [bookpositionData, bookposition]);

  const closeModal = () => {
    setBookPosition(false);
    setBookPositionData("");
  };

  const hasRows =
    (data?.bets?.length > 0) ||
    (data?.noBet?.length > 0) ||
    (data?.yesBet?.length > 0);
  // console.log(
  //   data.noBet[0]?.lossRunRange,
  //   data.yesBet[0]?.lossRunRange,
  //   data.noBet[0]?.lossRunRange + 1,
  //   data.yesBet[0]?.lossRunRange - 1,
  //   "data"
  // );
  // console.log(
  //   data.noBet[0]?.positionLoseAmount,
  //   data.yesBet[0]?.positionLoseAmount,
  //   "data"
  // );
  // const [lost,setLoss] = useState({

  // })
  const open = bookposition && !isEmpty(bookpositionData);

  if (isDesktop) {
    const renderRows = () => {
      const rows = [];
      data?.bets?.forEach((res, i) => {
        rows.push(
          <tr key={`b${i}`}>
            <td style={rowTd}>{res.betRun}</td>
            <td style={{ ...rowTd, color: res.position >= 0 ? "#1e7e34" : "#d9534f" }}>
              {res.position >= 0 ? res.position : `(${res.position})`}
            </td>
          </tr>
        );
      });
      data?.noBet?.forEach((res, i) => {
        rows.push(
          <tr key={`n+${i}`}>
            <td style={rowTd}>{res.profitRunRange}</td>
            <td style={{ ...rowTd, color: "#1e7e34" }}>{res.positionProfitAmount}</td>
          </tr>,
          <tr key={`n-${i}`}>
            <td style={rowTd}>{res.lossRunRange}</td>
            <td style={{ ...rowTd, color: "#d9534f" }}>{`(- ${res.positionLoseAmount})`}</td>
          </tr>,
          <tr key={`n2-${i}`}>
            <td style={rowTd}>{res.lossRunRange + 1}</td>
            <td style={{ ...rowTd, color: "#d9534f" }}>{`(- ${res.positionLoseAmount})`}</td>
          </tr>
        );
      });
      data?.yesBet?.forEach((res, i) => {
        rows.push(
          <tr key={`y+${i}`}>
            <td style={rowTd}>{res.profitRunRange}</td>
            <td style={{ ...rowTd, color: "#1e7e34" }}>{res.positionProfitAmount}</td>
          </tr>,
          <tr key={`y-${i}`}>
            <td style={rowTd}>{res.lossRunRange}</td>
            <td style={{ ...rowTd, color: "#d9534f" }}>{`(- ${res.positionLoseAmount})`}</td>
          </tr>,
          <tr key={`y2-${i}`}>
            <td style={rowTd}>{res.lossRunRange - 1}</td>
            <td style={{ ...rowTd, color: "#d9534f" }}>{`(- ${res.positionLoseAmount})`}</td>
          </tr>
        );
      });
      return rows;
    };

    return (
      <div
        style={{
          display: open ? "flex" : "none",
          position: "fixed",
          inset: 0,
          background: "rgba(0,0,0,0.45)",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 9999,
        }}
        onClick={closeModal}
      >
        <div
          onClick={(e) => e.stopPropagation()}
          style={{
            width: "340px",
            maxWidth: "90vw",
            background: "#fff",
            borderRadius: "6px",
            overflow: "hidden",
            boxShadow: "0 10px 40px rgba(0,0,0,0.35)",
            fontFamily: "Tahoma, Helvetica, sans-serif",
          }}
        >
          {/* Header */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              background: "linear-gradient(180deg, #2e4b5e 0%, #243a48 100%)",
              color: "#fff",
              padding: "8px 12px",
              fontSize: "14px",
              fontWeight: 700,
            }}
          >
            <span>Book</span>
            <span
              role="button"
              onClick={closeModal}
              style={{ cursor: "pointer", fontSize: "16px", lineHeight: 1 }}
            >
              ✕
            </span>
          </div>

          {/* Market name */}
          {bookpositionData?.fancyName && (
            <div style={{ padding: "8px 12px", fontSize: "13px", fontWeight: 700, color: "#1e1e1e", borderBottom: "1px solid #eee" }}>
              {bookpositionData.fancyName}
            </div>
          )}

          {/* Table */}
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <th style={headTh}>Run</th>
                <th style={headTh}>Amount</th>
              </tr>
            </thead>
            <tbody>
              {hasRows ? (
                renderRows()
              ) : (
                <tr>
                  <td colSpan={2} style={{ ...rowTd, textAlign: "center", color: "#888", padding: "16px 0" }}>
                    No data!
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  return (
    <div
      id="fancyBetBookLeftSide"
      className="overlay"
      style={{
        display: bookposition && !isEmpty(bookpositionData) ? "flex" : "none",
      }}
    >
      <div id="sideWrap" className="side-wrap full-pop">
        <div className="side-head">
          <h3 className="">Book Position</h3>
          <a
            className="close"
            href="javascript:void(0)"
            onClick={() => {
              setBookPosition(false);
              setBookPositionData("");
            }}
          >
            Close
          </a>
        </div>
        <div id="sideContent" className="side-content">
          <div className="path-wrap">
            <ul>
              <li id="headerName">{bookpositionData?.fancyName}</li>
            </ul>
          </div>
          <table id="table" className="table table-fancy">
            <tbody>
              <tr>
                <th width="40%">Runs</th>
                <th width="60%">Amount</th>
              </tr>
              <tr id="trTemp">
                <td id="runs" className="">
                  <strong></strong>
                </td>
                <td id="exposure" className="">
                  <strong></strong>
                </td>
              </tr>

              {data?.bets?.length > 0 &&
                data?.bets?.map((res) => {
                  return (
                    <>
                      <tr id="runsEx" style={{ display: "table-row" }}>
                        <td id="runs" className="col-back">
                          {res.betRun}
                        </td>
                        <td id="exposure" className="col-back">
                          {(res.position >= 0) ? res.position : <span  style={{color:`red`}}>({res.position})</span>}
                        </td>
                      </tr>
                    </>
                  );
                })}

              {data?.noBet?.length > 0 &&
                data?.noBet?.map((res) => {
                  return (
                    <>
                      <tr id="runsEx" style={{ display: "table-row" }}>
                        <td id="runs" className="col-back">
                          {res.profitRunRange}
                        </td>
                        <td id="exposure" className="col-back">
                          {res.positionProfitAmount}
                        </td>
                      </tr>
                      <tr>
                        <td id="runs" className="col-lay">
                          {res.lossRunRange}
                        </td>
                        <td id="exposure" className="col-lay text-danger">
                          {`(- ${res.positionLoseAmount})`}
                        </td>
                      </tr>
                      <tr>
                        <td id="runs" className="col-lay ">
                          {res.lossRunRange + 1}
                        </td>
                        <td id="exposure" className="col-lay text-danger">
                          {`(- ${res.positionLoseAmount})`}
                        </td>
                      </tr>
                    </>
                  );
                })}
              {data?.yesBet?.length > 0 &&
                data?.yesBet?.map((res) => {
                  return (
                    <>
                      <tr id="runsEx" style={{ display: "table-row" }}>
                        <td id="runs" className="col-back">
                          {res.profitRunRange}
                        </td>
                        <td id="exposure" className="col-back">
                          {res.positionProfitAmount}
                        </td>
                      </tr>
                      <tr>
                        <td id="runs" className="col-lay">
                          {res.lossRunRange}
                        </td>
                        <td id="exposure" className="col-lay text-danger">
                          {`(- ${res.positionLoseAmount})`}
                        </td>
                      </tr>
                      <tr>
                        <td id="runs" className="col-lay">
                          {res.lossRunRange - 1}
                        </td>
                        <td id="exposure" className="col-lay text-danger">
                          {`(- ${res.positionLoseAmount})`}
                        </td>
                      </tr>
                    </>
                  );
                })}
              {/* <tr id="runsEx" style={{ display: "table-row" }}>
                <td id="runs" className="col-back">
                  <strong>2</strong>
                </td>
                <td id="exposure" className="col-back">
                  <strong> 100.00</strong>
                </td>
              </tr>
              <tr id="runsEx" style={{ display: "table-row" }}>
                <td id="runs" className="col-lay">
                  <strong>3</strong>
                </td>
                <td id="exposure" className="col-lay">
                  <strong className="red">( 115.00)</strong>
                </td>
              </tr>
              <tr id="runsEx" style={{ display: "table-row" }}>
                <td id="runs" className="col-lay">
                  <strong>4</strong>
                </td>
                <td id="exposure" className="col-lay">
                  <strong className="red">( 115.00)</strong>
                </td>
              </tr> */}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default BookPosition;
